import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useApi } from "../../api";
import { n0, n2 } from "../../lib/format";
import { Notice, Stat } from "../../lib/ui";

/* One End of Day closing – port of end_of_day_details.php (API: /api/eod/<id>). Route /end_of_day_details/:id (or ?id=). Print and CSV export. */

export default function EodDetails() {
  const api = useApi();
  const { id: pid } = useParams();
  const [qs] = useSearchParams();
  const id = pid || qs.get("id");
  const [r, setR] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { if (id) api.get(`/api/eod/${id}`).then(setR).catch((e) => setError(e.message)); }, [api, id]);
  const exportCsv = () => {
    const rows = [["Date", r.closing_date], ["Cashier", r.username], ["Transactions", r.total_transactions], ["Cash in", r.total_sales_amount], ["Cash out", r.total_expenses_amount],
      ["Expected", r.expected_cash_balance], ["Actual", r.actual_cash_count], ["Variance", r.cash_variance], [], ["Denomination", "Quantity", "Subtotal"],
      ...r.denominations.filter((x) => x.count > 0).map((x) => [x.value, x.count, x.total]), [], ["Notes", r.notes || ""]];
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([rows.map((x) => x.map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",")).join("\n")], { type: "text/csv" }));
    a.download = `end_of_day_${r.closing_date}.csv`; a.click();
  };
  const v = r?.cash_variance || 0;
  const long = r && new Date(r.closing_date + "T00:00:00").toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  return (
    <main className="pg" style={{ maxWidth: "64rem" }}>
      <nav className="crumbs no-print"><Link to="/dashboard">Home</Link><i className="fas fa-chevron-right" /><Link to="/end_of_day_history">End of Day history</Link><i className="fas fa-chevron-right" /><span>Details</span></nav>
      <Notice notice={error && { tone: "err", text: error }} />
      {r && (
        <>
          <div className="pg-head"><div className="pg-title"><span className="chip"><i className="fas fa-moon text-indigo-500" /></span><div><h1>End of Day details</h1><p>{long}</p></div></div>
            <span className="no-print" style={{ display: "flex", gap: ".5rem" }}><button type="button" className="btn" onClick={() => window.print()}><i className="fas fa-print" /> Print</button>
              <button type="button" className="btn" onClick={exportCsv}><i className="fas fa-file-csv" /> Export</button></span></div>
          <div className="ui-stats">
            <Stat icon="fa-coins" tone="brand" label="Expected cash" value={n0(r.expected_cash_balance)} unit="TZS" />
            <Stat icon="fa-money-bill-wave" tone="up" label="Actual count" value={n0(r.actual_cash_count)} unit="TZS" />
            <Stat icon={v > 0 ? "fa-arrow-up" : v < 0 ? "fa-arrow-down" : "fa-equals"} tone={v > 0 ? "up" : v < 0 ? "danger" : "muted"} label={v > 0 ? "Surplus" : v < 0 ? "Shortage" : "Balanced"} value={n0(Math.abs(v))} unit="TZS" />
            <Stat icon="fa-receipt" tone="muted" label="Transactions" value={n0(r.total_transactions)} />
            <Stat icon="fa-arrow-trend-up" tone="up" label="Cash in" value={n0(r.total_sales_amount)} unit="TZS" />
          </div>
          <div className="grid2">
            <section className="panel"><div className="tbl-wrap"><table className="tbl">
              <thead><tr><th>Denomination</th><th className="num">Quantity</th><th className="num">Subtotal</th></tr></thead>
              <tbody>{r.denominations.filter((x) => x.count > 0).map((x) => <tr key={x.value}><td className="mono">TZS {n0(x.value)}</td><td className="num mono">{n0(x.count)}</td><td className="num mono">{n2(x.total)}</td></tr>)}</tbody>
              <tfoot><tr><td colSpan={2}>Total cash count</td><td className="num mono">TZS {n2(r.denominations.reduce((s, x) => s + x.total, 0))}</td></tr></tfoot>
            </table></div></section>
            <section className="panel card-pad">
              <h3>Closing information</h3>
              <dl className="po-meta" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".7rem" }}>
                <div><dt>Cashier</dt><dd>{r.username}</dd></div><div><dt>Date</dt><dd>{r.closing_date}</dd></div>
                <div><dt>Time</dt><dd>{r.closing_datetime ? String(r.closing_datetime).slice(11, 16) : "–"}</dd></div><div><dt>Status</dt><dd><span className="pill-tag ok">{r.status}</span></dd></div>
                <div><dt>Report emailed</dt><dd>{r.email_sent ? `Yes${r.email_sent_at ? `, ${String(r.email_sent_at).slice(0, 16)}` : ""}` : "No"}</dd></div>
                <div><dt>Cash out</dt><dd className="mono">{n0(r.total_expenses_amount)}</dd></div>
              </dl>
              {r.notes && <div className="ui-notice warn" style={{ display: "block", marginTop: "1rem", whiteSpace: "pre-wrap", fontWeight: 400 }}><b>Notes</b><br />{r.notes}</div>}
            </section>
          </div>
        </>
      )}
    </main>
  );
}
